// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1KCuH","title":"ClientCherryInfo_title__1Uh8s","itemText":"ClientCherryInfo_itemText__3ClZh"};